import { Type } from "@sinclair/typebox";
import { WhatsllyGroupMember } from "@whatslly/types/WhatsllyGroup";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";

export const ThreadMessageType = Type.Union([
  Type.Literal("chat"),
  Type.Literal("sticker"),
  Type.Literal("video"),
  Type.Literal("image"),
  Type.Literal("photo"),
  Type.Literal("document"),
  Type.Literal("ptt"),
  Type.Literal("ptv"),
  Type.Literal("vcard"),
  Type.Literal("multi_vcard"),
  Type.Literal("audio"),
  Type.Literal("poll_creation"),
  Type.Literal("event_creation"),
  Type.Literal("call_log"),
  Type.Literal("revoked"), // revoked = deleted
  Type.Literal("ciphertext"), // disappearing message
  Type.Literal("location"),
  // Telegram-specific media types
  Type.Literal("voice"),
  Type.Literal("video_note"),
  Type.Literal("animation"),
]);

export type ThreadMessageTypeType = TypeBoxToType<typeof ThreadMessageType>;

export const ThreadMessageQueueItem = Type.Object({
  p: Type.Optional(Type.String({ description: "phone" })),
  senderPhone: Type.Optional(Type.String({ description: "message sender phone" })),
  recipientPhone: Type.Optional(Type.String({ description: "message recipient phone" })),
  groupMessageMembers: Type.Optional(Type.Array(WhatsllyGroupMember)),
  groupSenderName: Type.Optional(Type.String({ description: "group message sender name" })),
  authorPhone: Type.Optional(Type.String({ description: "message author phone" })),
  groupId: Type.Optional(Type.String({ description: "groupId" })),
  pid: Type.Optional(Type.String({ description: "personId" })),
  pType: Type.Optional(Type.String({ description: "personType" })),
  id: Type.String({ description: "messageId" }),
  s: Type.Boolean({ description: "is message out" }),
  m: Type.Optional(Type.String({ description: "message text" })),
  transcriptText: Type.Optional(Type.String({ description: "transcript text" })),
  ts: Type.Number({ description: "message timestamp" }),
  latestUpdate: Type.Optional(Type.Number({ description: "message last update timestamp" })),
  ack: Type.Optional(Type.Union([Type.Literal("sent"), Type.Literal("delivered"), Type.Literal("read")])),
  wpid: Type.Optional(Type.String({ description: "whatslly person id" })),
  mdobj: Type.Optional(Type.Any({ description: "deprecated" })),
  type: Type.Optional(ThreadMessageType),
  fileDataURI: Type.Optional(Type.String()),
  fileName: Type.Optional(Type.String()),
  fileSize: Type.Optional(Type.Number()),
  fileInvalid: Type.Optional(Type.Union([Type.Literal("size"), Type.Literal("mimeType"), Type.Literal("messageType")])),
  templateId: Type.Optional(Type.String()),
  quotedMsgId: Type.Optional(Type.String()),
  tuvisCreatedById: Type.Optional(Type.String({ description: "override message created by with user id" })),
  isForwarded: Type.Optional(Type.Boolean({ description: "is message forwarded" })),
  isDisappearing: Type.Optional(Type.Boolean({ description: "is disappearing message" })),
  isEdited: Type.Optional(Type.Boolean({ description: "is message edited" })),
  isDeleted: Type.Optional(Type.Boolean({ description: "is message deleted" })),
  chatType: Type.Optional(
    Type.Union([Type.Literal("callRecording"), Type.Literal("newsletter"), Type.Literal("chat"), Type.Literal("status"), Type.Literal("broadcast")])
  ),
  location: Type.Optional(
    Type.Object({
      latitude: Type.Number(),
      longitude: Type.Number(),
    })
  ),
});

export type ThreadMessageQueueItemType = TypeBoxToType<typeof ThreadMessageQueueItem>;
